import { SERVICE_TYPE } from '@/api/type/commonTypes';
import { Images } from '@/assets';

type serviceTypeNameType = {
  label: string;
  type: SERVICE_TYPE;
  icon: string;
};

export const SERVICE_TYPE_NAME: serviceTypeNameType[] = [
  { label: 'R2 Guide', type: 'SURGICAL_GUIDE', icon: Images.R2GuideImg },
  { label: 'MEG Aligner', type: 'MEG_ALIGNER', icon: Images.MegAlignerImg },
  {
    label: 'C&B',
    type: 'CROWN_BRIDGE',
    icon: Images.CrownBridgeImg,
  },
  { label: 'Face Gide', type: 'FACE_GIDE', icon: Images.FaceGideImg },
  { label: 'QVD', type: 'R2_QVD', icon: Images.QvdImg },
];

export const getServiceLabel = (type: SERVICE_TYPE): string | undefined => {
  return SERVICE_TYPE_NAME.find((item) => item.type === type)?.label;
};
